/* -disable no-useless-constructor */
import React, { Component } from 'react';

import './styles.css';

class BatchEditMenu extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { children, selectedCount, entityName } = this.props;

    const childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child, {
        className: 'BatchEditMenu__button',
      }),
    );

    return (
      <div className="BatchEditMenu">
        <div className="BatchEditMenu__batch-counter-container">
          <span className="BatchEditMenu__batch-counter-number">
            {selectedCount}
          </span>
          <span className="BatchEditMenu__batch-counter-label">
            {entityName} selecionados
          </span>
        </div>
        <div>{childrenWithProps}</div>
      </div>
    );
  }
}

export default BatchEditMenu;
